import React from 'react';
import {View, Image, Text, TouchableOpacity, Platform} from 'react-native';
import {
   copyRight,
   FONT_FAMILY_REGULAR,
   isHoverEnabled,
   PRIVACY_POLICY,
   redirectToBrowser,
   TERM_AND_CONDITIONS,
} from './utils';

export const CopyRightForTab = props => {
   const [isHover, setHover] = React.useState(false);
   const [isHover2, setHover2] = React.useState(false);
   return !props.isPortrait && props.isCopyrightShown ? (
      <View
         style={{
            position: 'absolute',
            bottom: 0,
            height: 64,
            width: '100%',
            backgroundColor: '#5E718D',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            ...Platform.select({
               web: {
                  position: 'fixed',
               },
            }),
         }}>
         <Image
            source={require('../assets/norcat_logo_white.png')}
            style={{width: 175, height: 18, resizeMode: 'contain'}}
         />
         <View style={{flexDirection: 'row'}}>
            <TouchableOpacity
               onPress={() => {
                  const url = TERM_AND_CONDITIONS;
                  redirectToBrowser({url: url});
               }}
               onMouseEnter={() => {
                  setHover(true);
               }}
               onMouseLeave={() => {
                  setHover(false);
               }}
               style={{
                  borderWidth: 2,
                  borderColor:
                     isHover && isHoverEnabled ? '#b3b3b3' : '#F2F5FF33',
                  borderRadius: 3,
                  marginEnd: 24,
               }}>
               <Text
                  style={{
                     color: '#F2F5FF',
                     opacity: isHover && isHoverEnabled ? 1 : 0.6,
                     fontSize: 12,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                     padding: 8,
                  }}>
                  Terms and Conditions
               </Text>
            </TouchableOpacity>
            <TouchableOpacity
               onPress={() => {
                  const url = PRIVACY_POLICY;
                  redirectToBrowser({url: url});
               }}
               onMouseEnter={() => {
                  setHover2(true);
               }}
               onMouseLeave={() => {
                  setHover2(false);
               }}
               style={{
                  borderWidth: 2,
                  borderColor:
                     isHover2 && isHoverEnabled ? '#b3b3b3' : '#F2F5FF33',
                  borderRadius: 3,
                  marginEnd: 24,
               }}>
               <Text
                  style={{
                     color: '#F2F5FF',
                     opacity: isHover2 && isHoverEnabled ? 1 : 0.6,
                     fontSize: 12,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                     padding: 8,
                  }}>
                  Privacy Policy
               </Text>
            </TouchableOpacity>
            <View
               style={{
                  marginEnd: 24,
               }}>
               <Text
                  style={{
                     color: '#F2F5FF',
                     opacity: 0.6,
                     fontSize: 12,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                     padding: 8,
                  }}>
                  {copyRight}
               </Text>
            </View>
         </View>
      </View>
   ) : (
      <></>
   );
};
